import { z } from "zod";

import { i18n } from "~/lib/i18n";

import type { RouterOutputs } from "~/lib/trpc";

const analyticsPeriodSchema = z.enum(["15d", "30d", "90d"]);

export const analyticsSearchSchema = z.object({
  period: analyticsPeriodSchema.catch("15d"),
});

export const ANALYTICS_PERIOD_OPTIONS = [
  { label: i18n.t("analytics___15 días"), value: "15d" },
  { label: i18n.t("analytics___30 días"), value: "30d" },
  { label: i18n.t("analytics___90 días"), value: "90d" },
] as const;

export type AnalyticsPeriod = z.infer<typeof analyticsPeriodSchema>;
export type AnalyticsSearch = z.infer<typeof analyticsSearchSchema>;
export type AnalyticsSnapshot = RouterOutputs["admin"]["analytics"]["snapshot"];
